/**
 * ✨ キャンペーン Hub (v3.3 IA 刷新)
 *
 * 統合対象:
 *   - campaigns.list (ファネル一覧 / ファネル雛形 を Hub レベルで分離)
 *   - campaigns.landings (ランディング)
 *   - campaigns.forms (フォーム)
 *   - campaigns.referral (リフェラル)
 *   - campaigns.ad-images (広告画像)
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { CampaignsListPage } from './CampaignsListPage';
import { LandingsListPage } from '@/pages/landings/LandingsListPage';
import { FormsListPage } from '@/pages/forms/FormsListPage';
import { ReferralPage } from '@/pages/referral/ReferralPage';
import { AdImagesListPage } from '@/pages/ad-images/AdImagesListPage';

const TABS: TabSpec[] = [
  { tabKey: 'list',      label: 'ファネル一覧', featureId: 'campaigns.list',      render: () => <CampaignsListPage forcedView="campaigns" /> },
  { tabKey: 'templates', label: 'ファネル雛形', featureId: 'campaigns.list',      render: () => <CampaignsListPage forcedView="templates" /> },
  { tabKey: 'landings',  label: 'ランディング', featureId: 'campaigns.landings',  render: () => <LandingsListPage /> },
  { tabKey: 'forms',     label: 'フォーム',     featureId: 'campaigns.forms',     render: () => <FormsListPage /> },
  { tabKey: 'referral',  label: 'リフェラル',   featureId: 'campaigns.referral',  render: () => <ReferralPage /> },
  { tabKey: 'ad-images', label: '広告画像',     featureId: 'campaigns.ad-images', render: () => <AdImagesListPage /> },
];

export function CampaignsHubPage() {
  return <HubTabs tabs={TABS} defaultTab="list" />;
}
